import React from 'react'
import {
    SubNavigationSection,
    Section,
} from 'component-library/navigation/TheWestMainNavigation/components/sub_navigation/components/subNavigationSection'
import {
    StyledSubNav,
    StyledSubNavTitle,
} from 'component-library/navigation/TheWestMainNavigation/components/sub_navigation/subNavigation.styled'
import { NavEventArgs } from 'common/events/nav-event-types'

export interface Props {
    openedItem?: string
    subNavSections: Section[]
    onClick?: (args: NavEventArgs) => void
}

export class SubNavigation extends React.Component<Props, { openedItem: string | null }> {
    constructor(props: Props) {
        super(props)
        this.state = {
            openedItem: props.openedItem || null,
        }
    }

    handleToggleClick = (clickedSection: string) => {
        if (this.state.openedItem === clickedSection) {
            this.setState({ openedItem: null })
        } else {
            this.setState({ openedItem: clickedSection })
        }
    }

    render() {
        return (
            <StyledSubNav role="navigation">
                <StyledSubNavTitle>All Sections</StyledSubNavTitle>

                {this.props.subNavSections &&
                    this.props.subNavSections.map(section => {
                        if (section.subNavLinks.length > 0) {
                            return (
                                <SubNavigationSection
                                    key={section.sectionName}
                                    section={section}
                                    opened={this.state.openedItem === section.sectionName}
                                    expandToggleClicked={() =>
                                        this.handleToggleClick(section.sectionName)
                                    }
                                    onClick={this.props.onClick}
                                />
                            )
                        }
                        return <React.Fragment key={section.sectionName} />
                    })}
            </StyledSubNav>
        )
    }
}
